"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuProvider = void 0;
var react_1 = __importStar(require("react"));
var MenuContext_1 = require("./MenuContext");
var PopoverProvider_1 = require("./PopoverProvider");
var useMenu_1 = require("./useMenu");
var MenuItem_1 = require("./MenuItem");
var flattenChildren = function (children) {
    return react_1.default.isValidElement(children) && children.type === react_1.default.Fragment ? children.props.children : children;
};
var MenuProvider = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children;
    var popoverProps = react_1.default.useContext(PopoverProvider_1.PopoverContext).popoverProps;
    // First child is PopoverInner, then the next child is a single Menu with MenuItem children
    // React.Children.toArray flattens the array to deal with any React.Fragment that might be wrapped around the MenuItems
    var menuItemChildrenArray = flattenChildren(Array.isArray(children) ? (_e = (_d = (_c = (_b = children[0]) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.props) === null || _e === void 0 ? void 0 : _e.children : []);
    var _f = popoverProps !== null && popoverProps !== void 0 ? popoverProps : {}, isOpen = _f.isOpen, onClose = _f.onClose, setIsOpen = _f.setIsOpen;
    var _g = (0, useMenu_1.useMenu)({
        isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
        setIsOpen: function (isOpen) {
            if (onClose) {
                onClose(isOpen);
            }
            if (setIsOpen) {
                setIsOpen(isOpen);
            }
        },
        totalItems: react_1.Children.count(menuItemChildrenArray),
        isItemDisabled: function (index) {
            var _a;
            if (Array.isArray(menuItemChildrenArray)) {
                var currentChild = menuItemChildrenArray[index];
                return ((_a = currentChild === null || currentChild === void 0 ? void 0 : currentChild.props) === null || _a === void 0 ? void 0 : _a.disabled) || (react_1.default.isValidElement(currentChild) && currentChild.type !== MenuItem_1.MenuItem);
            }
        },
    }), getMenuProps = _g.getMenuProps, getItemProps = _g.getItemProps, getTriggerProps = _g.getTriggerProps, highlightedIndex = _g.highlightedIndex;
    return (react_1.default.createElement(MenuContext_1.MenuContext.Provider, { value: { getMenuProps: getMenuProps, getItemProps: getItemProps, getMenuTriggerProps: getTriggerProps, highlightedIndex: highlightedIndex } }, children));
};
exports.MenuProvider = MenuProvider;
